function u(n) {
  for (let e = 1, l = arguments.length; e < l; e++) {
    let r = arguments[e] || {};
    for (let t in r)
      if (r.hasOwnProperty(t)) {
        let o = r[t];
        o !== void 0 && (n[t] = o);
      }
  }
  return n;
}
export {
  u as default
};
